module.exports = __webpack_public_path__ + "static/media/explosion.03f34935.gif";